import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods, FieldError } from "react-hook-form";
import { IStreetsResponse } from "./Interface/IAddressForm";

interface IStreets {
    control: UseFormMethods["control"];
    prefix?: string;
    error: FieldError | undefined;
    streets: IStreetsResponse | undefined;
    disabled: boolean;
}

export const StreetsDropdown = (props: IStreets) => {
    const { t } = useTranslation(["address", "validation"]);
    const { control, error, streets, prefix, disabled } = props;

    const namePrefix = prefix ? `${prefix}.` : "";
    const idPrefix = prefix ? `${prefix}-` : "";

    const streetsList = streets?.streets.map((item) => ({ value: item.street, label: item.street }));

    return (
        <Controller
            control={control}
            name={`${namePrefix}street`}
            rules={{
                required: t("validation:required"),
            }}
            render={(renderProps) => (
                <TextField
                    disabled={disabled}
                    className="xtest_title_input"
                    fullWidth
                    error={Boolean(error)}
                    helperText={error?.message}
                    id={`${idPrefix}street`}
                    inputRef={renderProps.ref}
                    label={`${t("address:street")} *`}
                    margin="dense"
                    name={renderProps.name}
                    select
                    value={renderProps.value || ""}
                    onChange={(event) => {
                        return renderProps.onChange(event);
                    }}
                >
                    {streetsList?.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
